/* eslint-disable-next-line no-restricted-imports */
import type { FreeDeliveryConfig } from '@jane/shared/models';

export const isEligibleForFreeDeliveryConfig = ({
  discountedSubtotal = 0,
  freeDeliveryConfig,
}: {
  discountedSubtotal?: number;
  freeDeliveryConfig?: FreeDeliveryConfig;
}): boolean => {
  const subtotalMeetsCartMinimum = freeDeliveryConfig?.cart_minimum
    ? discountedSubtotal >= freeDeliveryConfig?.cart_minimum
    : true;

  return subtotalMeetsCartMinimum;
};

export const applicableFreeDeliveryConfig = ({
  discountedSubtotal,
  freeDeliveryConfigs,
}: {
  discountedSubtotal?: number;
  freeDeliveryConfigs?: Readonly<FreeDeliveryConfig[]>;
}) =>
  (freeDeliveryConfigs ?? []).find((freeDeliveryConfig) =>
    isEligibleForFreeDeliveryConfig({
      freeDeliveryConfig,
      discountedSubtotal,
    })
  );
